import { render, staticRenderFns } from "./ImprovedSurveyList.vue?vue&type=template&id=ba21661c&scoped=true&"
import script from "./ImprovedSurveyList.vue?vue&type=script&lang=js&"
export * from "./ImprovedSurveyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba21661c",
  null
  
)

export default component.exports